const prefix = '@@search/';

export const FETCH_SEARCH = `${prefix}FETCH_SEARCH`;
export const FETCH_SEARCH_SUCCESS = `${prefix}FETCH_SEARCH_SUCCESS`;
export const FETCH_SEARCH_ERROR = `${prefix}FETCH_SEARCH_ERROR`;
